module.exports = __webpack_public_path__ + "static/debbie-ecbc729db5d8f387922272e02018d849.png";